import { createReducer, on } from '@ngrx/store';

import { SubmitMyReportResponse, reportAction } from './reports.actions';

export interface ReportState {
  isSuccess: boolean;
  exportFileResponse: { fileName: string; file: Blob };
  isMyReportSuccess: boolean;
  exportMyReportResponse: SubmitMyReportResponse;
  pdfReport: any;
  error: any;
}

export const initialState: ReportState = {
  isSuccess: null,
  exportFileResponse: null,
  isMyReportSuccess: null,
  exportMyReportResponse: null,
  pdfReport: null,
  error: null
};

export const reportReducer = createReducer<ReportState>(
  initialState,
  on(reportAction.clearAllStates, () => {
    return { ...initialState };
  }),
  on(reportAction.exportReportFileError, (state, { isSuccess, error }) => {
    return { ...state, isSuccess, error };
  }),
  on(reportAction.exportReportFileResponse, (state, { isSuccess, response, fileName }) => {
    return {
      ...state,
      isSuccess: isSuccess,
      exportFileResponse: { fileName, file: response }
    };
  }),
  on(reportAction.exportMyReportResponse, (state, { isSuccess, response }) => {
    return {
      ...state,
      isMyReportSuccess: isSuccess,
      exportMyReportResponse: response
    };
  }),
  on(reportAction.setPdfReport, (state, { payload }) => {
    return {
      ...state,
      pdfReport: payload
    };
  }),
  on(reportAction.clearPdfReportItems, (state) => {
    return {
      ...state,
      pdfReport: null
    };
  })
);
